export default {
  body: {
    label: 'Текст',
    info: `Вы можете использовать синтаксис **Markdown** для форматирования текста сообщения (посетите https://www.markdownguide.org для получения дополнительной информации).  
Также доступны некоторые переменные-заполнители:
- \`{{userTitleAndName}}\`: заменяется титулом и именем пользователя (например, "Г-н Иван")
- \`{{userName}}\`: заменяется именем пользователя (например, "Иван")`,
  },
  dateSent: 'Дата отправки',
  dateValidUntil: 'Дата действия до',
  deleteMessage: {
    confirmTitle: 'Вы уверены, что хотите удалить это сообщение?',
  },
  messageDeleted: 'Сообщение успешно удалено.',
  notificationType: {
    label: 'Тип уведомления',
    email: 'Электронная почта',
    push_notification: 'Уведомление в приложении',
  },
  preview: 'Предпросмотр',
  sendMessage: {
    label: 'Отправить сообщение',
    confirmTitle: 'Вы уверены, что хотите отправить это сообщение?',
  },
  status: {
    label: 'Статус',
    draft: 'Черновик',
    sent: 'Отправлено',
  },
  subject: 'Тема',
  target: {
    label: 'Целевая аудитория',
    emailsExcluded: {
      label: 'Исключенные электронные адреса',
      placeholder: 'Введите адрес электронной почты для исключения, затем нажмите кнопку Добавить',
    },
    emailsIncluded: {
      label: 'Включенные электронные адреса',
      placeholder: 'Введите адрес электронной почты для включения, затем нажмите кнопку Добавить',
    },
    userType: {
      label: 'Тип целевой аудитории',
      all: 'Все пользователи',
      system_admins: 'Системные администраторы',
      survey_managers: 'Менеджеры опросов',
      data_analysts: 'Аналитики данных',
      data_cleaners: 'Специалисты по очистке данных',
      data_editors: 'Редакторы данных',
      individual: 'Отдельные пользователи',
    },
  },
}
